import { browser } from "$app/environment";

declare global {
  interface Window {
    _rwq?: keyof Window;
    rewardful?: RewardfulFunction;
    [key: string]: any;
  }
}

type RewardfulFunction = {
  (...args: unknown[]): void;
  q?: unknown[][];
};

export function initRewardful(): void {
  if (!browser) return;

  if (window._rwq || window.rewardful || document.querySelector('script[src*="r.wdfl.co/rw.js"]')) {
    return;
  }

  try {
    (function (w: Window & typeof globalThis, r: keyof Window) {
      w._rwq = r;
      w[r] = ((...args: unknown[]) => {
        if (!w[r]!.q) w[r]!.q = [];
        w[r]!.q!.push(args);
      }) as RewardfulFunction;
    })(window, "rewardful");
  } catch (_e) {
    console.error("Failed to initialize Rewardful queue:", _e);
  }

  const script = document.createElement("script");
  script.src = "https://r.wdfl.co/rw.js";
  script.setAttribute("data-rewardful", "dcf2f4");
  script.async = true;

  script.onerror = () => {
    console.error("Failed to load Rewardful script");
  };

  document.head.appendChild(script);
}

export function loadRewardful(): void {
  initRewardful();
}
